/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MhCustomer } from '../../models/mh-customer';

export interface GetMedicalHistoryCustomerById$Params {
  id: string;
}

export function getMedicalHistoryCustomerById(http: HttpClient, rootUrl: string, params: GetMedicalHistoryCustomerById$Params, context?: HttpContext): Observable<StrictHttpResponse<MhCustomer>> {
  const rb = new RequestBuilder(rootUrl, getMedicalHistoryCustomerById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MhCustomer>;
    })
  );
}

getMedicalHistoryCustomerById.PATH = '/api/customers/{id}/medical-history';
